import {
  faAngleLeft,
  faChevronDown,
  faEye,
  faPen,
  faPlus,
  faTrashCan,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Modal, Table } from "react-bootstrap";
import "./Role.css";
import Add_offcanvas from "./add_offcanvas/Add_offcanvas";
import Edit_offcanvas from "./edit_offcanvas/Edit_offcanvas";
import rejectAnimation from "../../../../../animation/success_lottie/Reject_lottie.json";
import Success_modal from "../../../../../common_components/common_modal/success_modal/Success_modal";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../../../utils/IDS";
import CustomPaginate from "../../../../../../common/custompaginate/CustomPaginate";
import { Delete } from "../../../../../../features/admin/role_permmission/role/Slice";
import { Context } from "../../../../../../utils/context";
import { useDispatch } from "react-redux";

const Role = () => {
  const { isAllow: permissions, usertype, userdata } = useContext(Context);
  const dispatch = useDispatch();
  const isAdmin = userdata?.role === "Admin";

  const {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  } = IndexUse();

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [modalRejectShow, setModalRejectShow] = useState(false);
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showEditCanvas, setShowEditCanvas] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const courseRef = useRef(null);
  const handleStatusSelect = (status) => {
    console.log(status);
    setOpenStatus(false);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleDelete = async () => {
    const success = await deleteData(deleteId); //  CORRECT

    if (success) {
      setShowDeleteModal(false);
      setDeleteId(null);
      setSuccess(true);
    } else {
      setErr(true);
    }
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (courseRef.current && !courseRef.current.contains(e.target))
        setOpenStatus(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>
      <section className="Collage_intern application_section">
        <div className="serach_header">
          {/* Search */}
          <InputGroup className="search_box">
            <Form.Control
              placeholder="Search Role"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup>

          {country?.data?.length < 4 && (
            <div className="dropdown_wrapper">
              <button
                className="dark_btn"
                onClick={() => setShowAddCanvas(true)}
              >
                Add
                <div className="aap_icon_holder">
                  <FontAwesomeIcon icon={faPlus} />
                </div>
              </button>
            </div>
          )}
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Role</h5>

          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {country?.data?.length > 0 ? (
                  country?.data?.map((val, index) => (
                    <tr key={index}>
                      <td>
                        {(country?.current_page - 1) * country?.per_page +
                          index +
                          1}
                      </td>
                      <td>{val?.name}</td>
                      <td>
                        <div className="action_btn_holder">
                          {permissions?.includes(IDS.Permission.Roles.Edit) &&
                            val?.name !== "Admin" && (
                              <Button
                                className="eye_btn action_btn_icon"
                                onClick={() => setShowEditCanvas(val?.id)}
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </Button>
                            )}

                          {/* <Button
                            className="eye_btn action_btn_icon"
                            onClick={() => {
                              setDeleteId(val.id);
                              setShowDeleteModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrashCan} />
                          </Button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center fw-bold">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CustomPaginate
              currentPage={country?.current_page}
              totalPages={country?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>
      <Add_offcanvas
        show={showAddCanvas}
        setShow={setShowAddCanvas}
        setSuccess={setSuccess}
        setErr={setErr}
        setShowRejectModal={setShowRejectModal}
        handleClose={() => setShowAddCanvas(false)}
      />

      <Edit_offcanvas
        show={showEditCanvas}
        setShow={setShowEditCanvas}
        setSuccess={setSuccess}
        setErr={setErr}
        setShowRejectModal={setShowRejectModal}
        handleClose={() => setShowEditCanvas(false)}
      />

      <Success_modal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        message_text="Application Rejected"
        animationData={rejectAnimation}
      />

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this country?</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>

          <Button
            variant="danger"
            onClick={handleDelete} //  THIS IS WHERE YOU CALL IT
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Role;
